import React from 'react';
import PropTypes from 'prop-types';

class VHWrapper extends React.Component {
    static propTypes = {
        render: PropTypes.func.isRequired
    };
    state = { vh: 0 };
    componentDidMount() {
        this.setVH();
        window.addEventListener( 'resize', this.setVH );
    }

    componentWillUnmount() {
        window.removeEventListener( 'resize', this.setVH );
    }

    setVH = () => {
        const vh = Math.max( document.documentElement.clientHeight, window.innerHeight || 0 );
        this.setState( {  vh: vh } );
    };

    render = () => this.props.render( this.state );
}

export default VHWrapper;
